import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { hoverSidebar } from '../../redux/slices/sidebarslice';
import { AuthLogout } from '../../redux/slices/auth.slice';
import { useDispatch, useSelector } from 'react-redux';
import { BiLogOutCircle } from "react-icons/bi";
import { useTranslation } from 'react-i18next';
import Images from '../../assets/js/images';
import { Nav } from 'react-bootstrap';
import { Fragment } from 'react';

const Sidebar = ({ user }) => {
  const { type } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const path = window.location.pathname;
  const { hover } = useSelector(state => state.SidebarSlice);

  const handleLogout = (id) => {
    dispatch(AuthLogout({ id: id, navigate }));
    dispatch({ type: "LOGOUT", payload: "" });
  }

  const checkUrl = (npath) => {
    return path === npath ? 'mm-active' : '';
  }

  return (
    <Fragment>
      <div className="sidebar-wrapper" data-simplebar="true" onMouseEnter={() => {
        dispatch(hoverSidebar(hover ? false : true))
      }} onMouseLeave={() => {
        dispatch(hoverSidebar(hover ? false : true))
      }}>
        <div className="sidebar-header justify-content-center">
          <div>
            <img src={Images?.AdminLogo} className="logo-icon" alt="logo icon" />
          </div>
        </div>
        <Nav as="ul" className="metismenu" id="menu">
          <Nav.Item as="li">
            <NavLink to={`/insurance/dashboard`} className={({ isActive, isPending, }) =>
              `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl('/insurance')}`
            }>
              <div className="parent-icon">
                <svg width="1em" height="1em" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.25 8C2.25 8.41423 2.58579 8.75 3 8.75H9C9.41423 8.75 9.75 8.41423 9.75 8V3.5C9.75 3.08579 9.41423 2.75 9 2.75H3C2.58579 2.75 2.25 3.08579 2.25 3.5V8ZM8.25 15.5C8.25 15.9142 8.58577 16.25 9 16.25H15C15.4142 16.25 15.75 15.9142 15.75 15.5V11C15.75 10.5858 15.4142 10.25 15 10.25H9C8.58577 10.25 8.25 10.5858 8.25 11V15.5ZM9.75 11.75H14.25V14.75H9.75V11.75ZM2.25 15.5C2.25 15.9142 2.58579 16.25 3 16.25H6C6.41422 16.25 6.75 15.9142 6.75 15.5V11C6.75 10.5858 6.41422 10.25 6 10.25H3C2.58579 10.25 2.25 10.5858 2.25 11V15.5ZM3.75 14.75V11.75H5.25V14.75H3.75ZM3.75 7.25V4.25H8.25V7.25H3.75ZM15 8.75C15.4142 8.75 15.75 8.41423 15.75 8V3.5C15.75 3.08579 15.4142 2.75 15 2.75H12C11.5858 2.75 11.25 3.08579 11.25 3.5V8C11.25 8.41423 11.5858 8.75 12 8.75H15ZM14.25 7.25H12.75V4.25H14.25V7.25Z" fill="currentColor" />
                </svg>
              </div>
              <div className="menu-title">{t('dashboard')}</div>
            </NavLink>
          </Nav.Item>
          {user?.role === 'insurance' &&
            <>
              <Nav.Item as="li">
                <NavLink to="/insurance/forms/rider" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/insurance/forms/${type}`)}`
                }>
                  <div className="parent-icon">
                    <svg width="24" height="24" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.10734 3.47917C3.72331 1.8632 6.29803 1.79033 8.00045 3.26057C9.70179 1.79033 12.2765 1.8632 13.8925 3.47917C15.5055 5.09224 15.581 7.66067 14.1189 9.36313L8.94272 14.5572C8.44565 15.0542 7.65385 15.0768 7.13005 14.6249L7.05712 14.5572L1.88086 9.36313C0.418773 7.66067 0.494267 5.09224 2.10734 3.47917ZM3.05015 4.42197C1.91205 5.56007 1.87953 7.38507 2.9526 8.56247L3.05015 8.6646L7.99992 13.6143L11.535 10.0783L9.17839 7.7218L8.47132 8.42893C7.69025 9.20993 6.42392 9.20993 5.64287 8.42893C4.86183 7.64787 4.86183 6.38153 5.64287 5.60049L7.04365 4.19882C5.90187 3.28475 4.24709 3.32662 3.15232 4.32442L3.05015 4.42197ZM8.70699 6.30759C8.96732 6.04724 9.38945 6.04724 9.64979 6.30759L12.4778 9.13553L12.9497 8.6646C14.1212 7.49307 14.1212 5.59355 12.9497 4.42197C11.8115 3.28387 9.98652 3.25136 8.80919 4.32442L8.70699 4.42197L6.58568 6.54329C6.34393 6.78505 6.32666 7.16628 6.53388 7.42793L6.58568 7.48613C6.82745 7.72787 7.20865 7.74513 7.47032 7.53793L7.52852 7.48613L8.70699 6.30759Z" fill="currentColor" />
                    </svg>
                  </div>
                  <div className="menu-title">{t('insurance_policy')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/insurance/users" className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "mm-active" : ""
                }>
                  <div className="parent-icon"><i className='bx bx-user'></i>
                  </div>
                  <div className="menu-title">{t('users')}</div>
                </NavLink>
              </Nav.Item>
            </>
          }
          <Nav.Item as="li">
            <NavLink type="button" onClick={() => { handleLogout(user?._id) }}>
              <div className="parent-icon"><i><BiLogOutCircle style={{ transform: 'rotate(180deg)' }} /></i>
              </div>
              <div className="menu-title">{t('logout')}</div>
            </NavLink>
          </Nav.Item>
        </Nav>
      </div>
    </Fragment >
  )
}

export default Sidebar;